// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WarningModal_warningModal__1oGBC {
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  background: greenorange;
  z-index: 3000;
}
.WarningModal_warningModal__1oGBC > div {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 100%;
}

.WarningModal_warningMiddle__4KEnk {
  position: absolute;
  max-width: 400px;
  background: var(--background-quaternary);
  z-index: 3500;
  border-radius: 5px;
  padding: 15px 18px;
}
.WarningModal_warningMiddle__4KEnk > p {
  margin-top: 15px;
  color: var(--text-primary);
  font-size: 0.9em;
}

.WarningModal_warningHeader__jY\\+Eb {
  display: flex;
  align-items: center;
  gap: 10px;
}
.WarningModal_warningHeader__jY\\+Eb svg {
  width: 20px;
}
.WarningModal_warningHeader__jY\\+Eb path {
  stroke: rgb(255, 112, 112);
}
.WarningModal_warningHeader__jY\\+Eb h4 {
  color: rgb(255, 112, 112);
  font-size: 0.95em;
}

.WarningModal_btn__bNaFm {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  margin-top: 15px;
}
.WarningModal_btn__bNaFm button {
  padding: 7px 19px;
  border: 1px solid var(--border-secondary);
  color: var(--text-primary);
  border-radius: 5px;
  font-size: 0.8em !important;
}
.WarningModal_btn__bNaFm button:hover {
  background: var(--background-emphasis);
}

@media only screen and (max-width: 430px) {
  .WarningModal_warningMiddle__4KEnk {
    width: 90%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/WarningModal/WarningModal.module.scss"],"names":[],"mappings":"AAAA;EACC,eAAA;EACA,OAAA;EACA,MAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;AACD;AACC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AACF;;AAGA;EACC,kBAAA;EACA,gBAAA;EACA,wCAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AAAD;AAEC;EACC,gBAAA;EACA,0BAAA;EACA,gBAAA;AAAF;;AAIA;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AADD;AAGC;EACC,WAAA;AADF;AAIC;EACC,0BAAA;AAFF;AAKC;EAEC,yBAAA;EACA,iBAAA;AAJF;;AAQA;EACC,aAAA;EACA,qBAAA;EACA,yBAAA;EACA,gBAAA;AALD;AAOC;EACC,iBAAA;EACA,yCAAA;EACA,0BAAA;EACA,kBAAA;EACA,2BAAA;AALF;AAOE;EACC,sCAAA;AALH;;AAUA;EACC;IACC,UAAA;EAPA;AACF","sourcesContent":[".warningModal {\n\tposition: fixed;\n\tleft: 0;\n\ttop: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\theight: 100vh;\n\twidth: 100vw;\n\tbackground: greenorange;\n\tz-index: 3000;\n\n\t> div {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tposition: relative;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t}\n}\n\n.warningMiddle {\n\tposition: absolute;\n\tmax-width: 400px;\n\tbackground: var(--background-quaternary);\n\tz-index: 3500;\n\tborder-radius: 5px;\n\tpadding: 15px 18px;\n\n\t> p {\n\t\tmargin-top: 15px;\n\t\tcolor: var(--text-primary);\n\t\tfont-size: 0.9em;\n\t}\n}\n\n.warningHeader {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 10px;\n\n\tsvg {\n\t\twidth: 20px;\n\t}\n\n\tpath {\n\t\tstroke: rgb(255, 112, 112);\n\t}\n\n\th4 {\n\t\t// color: var(--text-primary);\n\t\tcolor: rgb(255, 112, 112);\n\t\tfont-size: 0.95em;\n\t}\n}\n\n.btn {\n\tdisplay: flex;\n\talign-items: flex-end;\n\tjustify-content: flex-end;\n\tmargin-top: 15px;\n\n\tbutton {\n\t\tpadding: 7px 19px;\n\t\tborder: 1px solid var(--border-secondary);\n\t\tcolor: var(--text-primary);\n\t\tborder-radius: 5px;\n\t\tfont-size: 0.8em !important;\n\n\t\t&:hover {\n\t\t\tbackground: var(--background-emphasis);\n\t\t}\n\t}\n}\n\n@media only screen and (max-width: 430px) {\n\t.warningMiddle {\n\t\twidth: 90%;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"warningModal": `WarningModal_warningModal__1oGBC`,
	"warningMiddle": `WarningModal_warningMiddle__4KEnk`,
	"warningHeader": `WarningModal_warningHeader__jY+Eb`,
	"btn": `WarningModal_btn__bNaFm`
};
export default ___CSS_LOADER_EXPORT___;
